import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { MdMenu } from "react-icons/md";
import { Bell, MessageCircle, Settings } from "lucide-react";
import EditProfileModal from "../pages/profile/EditProfileModal";
import Permiso from "../router/Permiso";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { ticketService } from "../services/TicketService";
import "./Header.css";

export const Header = ({
  user,
  isOpen,
  toggleSidebar,
  token,
}) => {
  const { handleLogout } = useContext(AuthContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notificaciones, setNotificaciones] = useState([]);
  const [messages, setMessages] = useState([]);
  const [showMessages, setShowMessages] = useState(false);
  const dropdownRef = useRef(null);
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  useEffect(() => {
    const fetchMensajesNoLeidos = async () => {
      try {
        const { tickets } = await ticketService.getTicketMessageNoLeido({ token });
        setMessages(tickets);
      } catch (error) {
        setNotificaciones("")
        console.error("Error al cargar mensajes no leídos:", error);
      }
    };

    if (user.permisos.includes("view_message")) {
      fetchMensajesNoLeidos();
    }
  }, [token, user?.id]);

  const handleSetting = () => {
    navigate("/admin/perfiles");
  };
  return (
    <div className="app-header">
      <div className="search-bar-container">
        <button className="icon-only" onClick={toggleSidebar}>
          <MdMenu style={{ color: "var(--color-primary)", fontSize: "24px" }} />
        </button>
        <div className="search-input-container">
          {/*  <Search className="search-icon" size={20} />
          <input
            type="text"
            placeholder="Ingresa una palabra clave para buscar..."
            className="search-input"
          /> */}
        </div>
      </div>
      <div className="search-actions">
        <Permiso permiso="menu_settings">
          <button className="search-button" onClick={handleSetting}>
            <Settings size={30} style={{ color: "#6b7280" }} />
          </button>
        </Permiso>
        <Permiso permiso="view_notifications">
          <div className="notification-wrapper">
            <button
              className="search-button"
              onClick={() => setShowNotifications(!showNotifications)}
            >
              <Bell size={30} style={{ color: "#6b7280" }} />
            </button>

            {showNotifications && (
              <div className="notification-menu">
                {notificaciones.length === 0 ? (
                  <p className="notification-empty">No hay notificaciones</p>
                ) : (
                  <ul>
                    {notificaciones.map((n) => (
                      <li key={n.id} className="notification-item">
                        <strong>{n.titulo}</strong>
                        <p>{n.mensaje}</p>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        </Permiso>
        <Permiso permiso="view_message">
          <div className="notification-wrapper">
            <button
              className="search-button"
              onClick={() => setShowMessages(!showMessages)}
            >
              <MessageCircle size={30} style={{ color: "#6b7280" }} />
              {messages.length > 0 && (
                <span
                  className="badge"
                  style={{
                    position: "absolute",
                    top: 0,
                    right: -4,
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: "50%",
                    padding: "2px 6px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    lineHeight: "1",
                  }}
                >
                  {messages.length}
                </span>
              )}
            </button>

            {showMessages && (
              <div className="notification-menu">
                {messages.length === 0 ? (
                  <p className="notification-empty">No hay Mensajes</p>
                ) : (
                  <ul>
                    {messages.map((n) => (
                      <li key={n.ticket_id} className="notification-item">
                        <Link to={`/admin/soporte/consultar/${n.ticket_id}`} style={{ textDecoration: "none", color: "inherit" }}>
                          <strong>Nuevo mensaje</strong>
                          <p>Tienes  mensaje en la solicitud # {n.ticket_id}</p>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        </Permiso>

        <div className="user-menu" ref={dropdownRef}>
          <button className="search-button" onClick={toggleDropdown}>
            <span className="user-initial">
              {user?.nombre ? user.nombre.charAt(0).toUpperCase() : "U"}{" "}
            </span>{" "}
            <span className="user-name-text">
              {user?.nombre ? user.nombre.toUpperCase() : ""}
            </span>
          </button>
          {isDropdownOpen && (
            <div className="dropdown-menu">
              <div className="user-name">
                <div className="logo-subtitle">
                  {user?.perfil_nombre || "Administrador"}
                </div>
              </div>
              <Permiso permiso="edit_profile">
                <button
                  className="dropdown-item"
                  onClick={() => setShowEditProfileModal(true)}
                >
                  Editar perfil
                </button>
              </Permiso>
              <button className="dropdown-item" onClick={handleLogout}>
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
      <EditProfileModal
        open={showEditProfileModal}
        onClose={() => setShowEditProfileModal(false)}
        user={user}
        token={token}
        onUpdate={(updatedUser) => {
          setShowEditProfileModal(false);
        }}
      />
    </div>
  );
};

Header.propTypes = {
  user: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};
